<mat-card class="dialog-card">
  <mat-card-header class="header">
    <mat-card-title class="title">
      Détails du client {{ dataComparison.correspondance?.codeDivalto }} -
      {{ dataComparison.correspondance?.libelleDivalto }}
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="summary-section">
      <div class="summary-item">
        <span class="summary-label">Postes Divalto :</span>
        <span class="summary-value">{{
          dataComparison.divaltoData?.nbPostes
        }}</span>
      </div>
      <div class="summary-item">
        <span class="summary-label">Serveurs Divalto :</span>
        <span class="summary-value">{{
          dataComparison.divaltoData?.nbServeurs
        }}</span>
      </div>
      <div class="summary-item">
        <span class="summary-label">Équipements Divalto :</span>
        <span class="summary-value">{{
          dataComparison.divaltoData?.nbEquipements
        }}</span>
      </div>
    </div>

    <div class="summary-section">
      <div class="summary-item">
        <span class="summary-label">ATS Divalto :</span>
        <span class="summary-value">{{
          dataComparison.divaltoData?.nbAts
        }}</span>
      </div>
      <div class="summary-item">
        <span class="summary-label">MDR Divalto :</span>
        <span class="summary-value">{{
          dataComparison.divaltoData?.nbMdr
        }}</span>
      </div>
      <div class="summary-item">
        <span class="summary-label">EDR Divalto :</span>
        <span class="summary-value">{{
          dataComparison.divaltoData?.nbEdr
        }}</span>
      </div>
    </div>
    <div class="summary-section">
      <div class="summary-item">
        <span class="summary-label">CRY Divalto :</span>
        <span class="summary-value">{{
          dataComparison.divaltoData?.nbCry
        }}</span>
      </div>
      <div class="summary-item">
        <span class="summary-label">PATCH Divalto :</span>
        <span class="summary-value">{{
          dataComparison.divaltoData?.nbPatch
        }}</span>
      </div>
    </div>
    <div class="tables-container">
      <!-- Table RG -->
      <div class="divTable">
        <div class="tableHeader" >
          <div class="filtre">
            <div class="toggles">
              <mat-slide-toggle [(ngModel)]="rgFilters.errors" (change)="onRgFiltersChange()">
                Erreurs uniquement
              </mat-slide-toggle>
            
              <mat-slide-toggle [(ngModel)]="rgFilters.serveurs" (change)="onRgFiltersChange()" >
                Serveurs
              </mat-slide-toggle>
            
              <mat-slide-toggle [(ngModel)]="rgFilters.postes" (change)="onRgFiltersChange()" >
                Postes
              </mat-slide-toggle>
            
              <mat-slide-toggle [(ngModel)]="rgFilters.equipements" (change)="onRgFiltersChange()" >
                Équipements
              </mat-slide-toggle>
            </div>
            
          </div>
          
        
          <div class="table-title">Liste des entités RG</div>
        </div>
        

        <table mat-table [dataSource]="devicesRg" class="modal-table">
          <ng-container matColumnDef="nomAgent">
            <th mat-header-cell *matHeaderCellDef>Nom</th>

            <td mat-cell *matCellDef="let element" class="cell-content">
              <span class="text">
                @if(element.type.code=='EQUI') {{{ element.nom }}} @else
                {{{ element.nomAgent }}}
              </span>

              @if (element.haveIncidentAffranchi) {
              <mat-icon class="icon-right" matTooltip="Ce device est affranchi">
                report_off
              </mat-icon>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="os">
            <th mat-header-cell *matHeaderCellDef>OS</th>
            <td mat-cell *matCellDef="let element">{{ element.os }}</td>
          </ng-container>

          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let element">
              {{ element.type.libelle }}
            </td>
          </ng-container>

          <ng-container matColumnDef="affranchir">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let element" class="no-click-cell">
              <div class="cell-with-icon" style="text-align: center; justify-content: center;">
                <div class="icon-wrapper">
                  @if(shouldShowAffranchir(element, 'rg')){
                    <mat-icon
                      class="icon-item"
                      matTooltip="Affranchir l'incident"
                      (click)="$event.stopPropagation(); affranchirDevice(element, 'rg');"
                    >
                      report_off
                    </mat-icon>
                  }
                </div>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedRgColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedRgColumns"
            [ngClass]="isMatchingRow(row, 'rg')"
            (click)="onRowRgClicked(row)"
          ></tr>
        </table>
        <mat-paginator
          [length]="pageRgInformations.totalElements"
          [pageSize]="pageRgInformations.size"
          [pageSizeOptions]="[10, 25, 50]"
          (page)="onPageRgEvent($event)"
          style="margin-top: 16px"
        >
        </mat-paginator>
      </div>

      <!-- Table BIT -->
      <div class="divTable">
        <div class="tableHeader" style="margin-bottom: 12px">
          <div class="filtre">
            <div class="toggles">
              <mat-slide-toggle [(ngModel)]="bitFilters.errors" (change)="onBitFiltersChange()">
                Erreurs uniquement
              </mat-slide-toggle>
            
              <mat-slide-toggle [(ngModel)]="bitFilters.serveurs" (change)="onBitFiltersChange()" >
                Serveurs
              </mat-slide-toggle>
            
              <mat-slide-toggle [(ngModel)]="bitFilters.postes" (change)="onBitFiltersChange()" >
                Postes
              </mat-slide-toggle>
            
              <mat-slide-toggle [(ngModel)]="bitFilters.equipements" (change)="onBitFiltersChange()" >
                Équipements
              </mat-slide-toggle>
            </div>
            
          </div>

          <div class="table-title">Liste des entités BIT</div>
        </div>

        <table mat-table [dataSource]="devicesBit" class="modal-table">
          <ng-container matColumnDef="nom">
            <th mat-header-cell *matHeaderCellDef>Nom</th>

            <td mat-cell *matCellDef="let element" class="cell-content">
              <span class="text">
                {{ element.nom }}
              </span>

              @if (element.haveIncidentAffranchi) {
              <mat-icon class="icon-right" matTooltip="Ce device est affranchi">
                report_off
              </mat-icon>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="os">
            <th mat-header-cell *matHeaderCellDef>OS</th>
            <td mat-cell *matCellDef="let element">{{ element.os }}</td>
          </ng-container>

          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let element">
              {{ element.type.libelle }}
            </td>
          </ng-container>

          <ng-container matColumnDef="ATS">
            <th mat-header-cell *matHeaderCellDef>ATS</th>
            <td mat-cell *matCellDef="let element">
              {{ element.haveAts ? "Oui" : "Non" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="MDR">
            <th mat-header-cell *matHeaderCellDef>MDR</th>
            <td mat-cell *matCellDef="let element">
              {{ element.haveMdr ? "Oui" : "Non" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="EDR">
            <th mat-header-cell *matHeaderCellDef>EDR</th>
            <td mat-cell *matCellDef="let element">
              {{ element.type.haveEdr ? "Oui" : "Non" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="CRY">
            <th mat-header-cell *matHeaderCellDef>CRY</th>
            <td mat-cell *matCellDef="let element">
              {{ element.haveCry ? "Oui" : "Non" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="PATCH">
            <th mat-header-cell *matHeaderCellDef>PATCH</th>
            <td mat-cell *matCellDef="let element">
              {{ element.havePatch ? "Oui" : "Non" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="affranchir">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let element" class="no-click-cell">
              <div class="cell-with-icon" style="text-align: center; justify-content: center;">
                <div class="icon-wrapper">
                  @if(shouldShowAffranchir(element, 'bit')){
                    <mat-icon
                      class="icon-item"
                      matTooltip="Affranchir l'incident"
                      (click)="$event.stopPropagation(); affranchirDevice(element,'bit');"
                    >
                      report_off
                    </mat-icon>
                  }
                </div>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedBitColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedBitColumns"
            [ngClass]="isMatchingRow(row, 'bit')"
            (click)="onRowBitClicked(row)"
          ></tr>
        </table>
        <mat-paginator
          [length]="pageBitInformations.totalElements"
          [pageSize]="pageBitInformations.size"
          [pageSizeOptions]="[10, 25, 50]"
          (page)="onPageBitEvent($event)"
          style="margin-top: 16px"
        >
        </mat-paginator>
      </div>
    </div>
  </mat-card-content>
</mat-card>
